export enum QuestionType {
    Checkbox,
    Dropdown,
    AcknowledgeEndTime,
    DOB,
    ReasonsForVisit,
    DietaryRestrictions,
    Text,
    DietaryRestrictionsText,
}

export type QuestionSource = 'merchant' | 'system-defined'

export function sourceTypeOfQuestionType(type: QuestionType): QuestionSource {
    switch (type) {
    case QuestionType.AcknowledgeEndTime:
        return 'system-defined'
    case QuestionType.DOB:
        return 'system-defined'
    case QuestionType.ReasonsForVisit:
        return 'system-defined'
    case QuestionType.DietaryRestrictions:
        return 'system-defined'
    case QuestionType.DietaryRestrictionsText:
        return 'system-defined'
    default:
        return 'merchant'
    }
}

export function sourceTypeOfQuestion(question: Question): QuestionSource {
    if (question.type === QuestionType.DOB && question.text) {
        return 'merchant'
    }
    return sourceTypeOfQuestionType(question.type)
}

export class Question {
    constructor(
        public id: string,
        public text: string,
        public required: boolean,
        public type: QuestionType,
        public options: string[],
        public reasonIds: string[],
        public active: boolean = true
    ) { }

    get isTickable(): boolean {
        return this.type === QuestionType.Checkbox || this.type === QuestionType.AcknowledgeEndTime
    }

    get merchantDisplayText(): string {
        if (this.type === QuestionType.AcknowledgeEndTime) {
            return 'I acknowledge when my booking ends'
        }
        if (this.type === QuestionType.DOB) {
            return this.text || 'Birthday'
        }
        if (this.type === QuestionType.DietaryRestrictions) {
            return 'Dietary Restrictions'
        }
        if (this.type === QuestionType.DietaryRestrictionsText) {
            return 'Dietary Restrictions (Text)'
        }
        return this.text
    }

    get bookingDisplayText(): string {
        if (this.type === QuestionType.AcknowledgeEndTime) {
            return 'End Time Acknowledged'
        }
        if (this.type === QuestionType.DOB) {
            return this.text || 'Birthday'
        }
        if (this.type === QuestionType.DietaryRestrictions) {
            return 'Dietary Restrictions'
        }
        if (this.type === QuestionType.DietaryRestrictionsText) {
            return 'Dietary Restrictions'
        }
        return this.text
    }
}
